<script>
    // import axios from "axios";
    
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import moment from "moment";
    import { mapGetters, mapActions, mapState } from "vuex";
    
    /**
     * Advanced table component
     */
    export default {
      page: {
        title: "Supplier Balance Details",
        meta: [
          {
            name: "description",
            content: appConfig.description,
          },
        ],
      },
      components: {
        Layout,
        PageHeader,
      },
      data() {
        return {
         current_date: moment(new Date()).format("YYYY-MM-DD"),
          title: "Supplier Balance Details",
          items: [
            {
              text: "Home",
              href: "#/",
            },
            {
              text: "Supplier Balance Details",
              active: true,
            },
          ],

          json_fields: {
            NAME: "supplier.name",
            CONTACT: "supplier.contact",
            DATE: "date",
            CATEGORY:"Category",
            PAID_VIA:"mode",
            DEBIT:"amount",
            CREDIT:"amountIn",  
            BALANCE:"newbalance",            
            RECORDED_BY:"user",
          },
          json_meta: [
            [
              {
                key: "charset",
                value: "utf-8",
              },
            ],
          ],

          total_amount:0,
          total_paid:0,
          total_balance:0,
          totalRows: 1,
          currentPage: 1,
          perPage: 10,
          pageOptions: [10, 25, 50, 100, 200, 1000],
          filter: null,
          todoFilter: null,
          filterOn: [],
          todofilterOn: [],
          sortDesc: false,
          totals:{
            totalin:0,
            totalout:0,
          },
          filterRecords:{
            id:atob(this.$route.params.id),
            datefrom: null,
            dateto: moment(new Date()).format("YYYY-MM-DD"),
          },
          fields: [
            {
              key: "date",
              sortable: true,
              label: "DATE",
            },
            {
              key: "Category",
              sortable: true,
              label: "CATEGORY",
            },
            {
              key: "mode",
              sortable: true,
              label: "PAID VIA",
            },
            {
              key: "amount",
              sortable: true,
              label: "DEBIT",
            },
            {
              key: "amountIn",
              sortable: true,
              label: "CREDIT",
            },            
            {
              key: "newbalance",
              sortable: true,
              label: "BALANCE",
            },
            {
              key: "actions",
              sortable: true,
              label: "ACTIONS",
            }        
           
          ],
         
        };
      },
      computed: {
        ...mapState("notification", [
          "notificationtype",
          "notification_message",
          "notification_show",
        ]),
        ...mapGetters("stock", ["SuppliersBalanceDetails","FilterStatus"]),
    
        /**
         * Total no. of records
         */
    
        rows() {
          return this.SuppliersBalanceDetails ? this.SuppliersBalanceDetails.length : 1;
        },
      },
      mounted() {
        // Set the initial number of items
        this.totalRows = this.SuppliersBalanceDetails ? this.SuppliersBalanceDetails.length : 1;
      },
      methods: {
        ...mapActions({
          FetchBalanceDetails: "stock/fetchSuppliersBalanceDetails",
        }),
        thousandSeperator(m) {
          if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
            return m
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          } else {
            return m;
          }
        },
       /**
         * Search the table data with search input
         */
        onFiltered(filteredItems) {
          // Trigger pagination to update the number of buttons/pages due to filtering
          this.totalRows = filteredItems.length;
          this.currentPage = 1;
        },
        Viewdetails(tid, category){
          if(category == 'Purchase'){
            this.$router.push(`/purchase_details/${btoa(tid)}`);
          }else if(category == 'Deposit'){
            this.$router.push(`/supplierdeposit_details/${btoa(tid)}`);
          }else if(category == 'Imported Creditor'){
            this.$router.push(`/creditor_details/${btoa(tid)}`);
          }
        },
        FilterRecords(){
          this.FetchBalanceDetails(this.filterRecords);
        },
        printDescriptiveLedger(){
          this.$router.push(`/supplier/descriptive_balancedetails/${btoa(this.filterRecords.id)}`);
        },
        printLedger(){
          this.$router.push(`/supplier/print_balance_details/${btoa(this.filterRecords.id)}/${btoa(this.filterRecords.datefrom)}/${btoa(this.filterRecords.dateto)}`);
        },
        Receipt_print(newValue) {      
          window.open(
            `https://${window.location.host}/receipts/supplierdepositreceipt.php?id=${btoa(newValue)}`
          );
        },
      },
      updated() {
        let total_in = 0;
        let total_out = 0;
        if(this.SuppliersBalanceDetails){
            this.SuppliersBalanceDetails.forEach((item)=>{
                total_in = total_in+parseInt(item.amountIn);
            });
            this.totals.totalin = total_in;
            this.SuppliersBalanceDetails.forEach((item)=>{
                total_out = total_out+parseInt(item.amount);
            });
            this.totals.totalout = total_out;
        }
      },
      created() {
        this.FetchBalanceDetails(this.filterRecords);
      },
    };
    </script>
    
    <template>
      <Layout>
        <Toasts
          :show-progress="true"
          :rtl="true"
          :max-messages="20"
          :time-out="3000"
          :closeable="false"
          :solid="true"
        ></Toasts>
        <div class="row py-3 text-center" v-if="SuppliersBalanceDetails && SuppliersBalanceDetails.length>0 && filterRecords.datefrom == null">
          <h4 class="text-primary text-uppercase">SUPPLIER PAYMENT REPORT FOR {{SuppliersBalanceDetails[0].supplier.name}} - {{SuppliersBalanceDetails[0].supplier.contact}} <br/></h4>
        </div>
        <div class="row py-3 text-center" v-if="SuppliersBalanceDetails && SuppliersBalanceDetails.length>0 && filterRecords.datefrom != null">
          <h4 class="text-primary text-uppercase">
            SUPPLIER PAYMENT REPORT FOR {{SuppliersBalanceDetails[0].supplier.name}} - {{SuppliersBalanceDetails[0].supplier.contact}} <br/>
            FROM {{ filterRecords.datefrom }} TO {{ filterRecords.dateto }}
          </h4>
        </div>
        <PageHeader :title="title" :items="items" />
        <div class="col-12">
            <div class="card">
              <div class="card-body">
                <div  class="row mb-3">
                  <div class="col-4"></div>
                  <div class="col-3 form-group mb-2">
                    <label>FROM</label>
                    <input
                      type="date"
                      v-model="filterRecords.datefrom"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-3 form-group">
                    <label>TO</label>
                    <input
                      v-model="filterRecords.dateto"
                      type="date"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-2 mt-4">
                    <button class="btn btn-primary" type="button" @click="FilterRecords()">
                      <span class="fa fa-filter"></span> Filter
                      <b-spinner
                        v-show="FilterStatus"
                        variant="light"
                        small
                        role="status"
                      ></b-spinner>
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <download-excel
                      class="btn"
                      style="background-color: #e612e6 !important; border-color: #e612e6 !important; color: #fff !important;"
                      :data="SuppliersBalanceDetails"
                      :fields="json_fields"
                      :worksheet="'SUPPLIER BALANCE DETAILS AS OF ' + current_date"
                      type="csv"
                      :name="'Supplierbalance_details ' + current_date + '.xls'"
                    >
                      Export <i class="fa fa-file-excel"></i>
                    </download-excel>
                  </div>
                  <div class="col-md-3" align="center">
                    <b-button @click="printDescriptiveLedger()"
                      style="background-color: #e612e6 !important; border-color: #e612e6 !important; color: #fff !important;"
                      >Detailed
                    </b-button>
                  </div>
                  <div class="col-md-3" align="center">
                    <b-button @click="printLedger()"
                      style="background-color: #e612e6 !important; border-color: #e612e6 !important; color: #fff !important;"
                      ><i class="fa fa-print"></i> Print
                    </b-button>
                  </div>
                  <div class="col-md-3" align="right">
                      <b-button @click="$router.go(-1)"
                        style="background-color: #e612e6 !important; border-color: #e612e6 !important; color: #fff !important;"
                        ><i class="fa fa-arrow-left"></i> Back
                      </b-button>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                          class="form-select form-select-sm"
                          v-model="perPage"
                          size="sm"
                          :options="pageOptions"
                        ></b-form-select
                        >&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                      <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                          v-model="filter"
                          type="search"
                          placeholder="Search..."
                          class="form-control form-control-sm ms-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive mb-0">
                  <b-table
                    class="datatables"
                    :items="SuppliersBalanceDetails"
                    :fields="fields"
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    @filtered="onFiltered"
                    >
                    <template #cell(amountIn)="data">
                    {{ thousandSeperator(data.item.amountIn) }}
                    </template>
                    <template #cell(amount)="data">
                    {{ thousandSeperator(data.item.amount) }}
                    </template>
                    <template #cell(actions)="data">                      
                      <b-button-group>
                        <b-button v-if="data.item.recno>0" size="sm" @click="Receipt_print(data.item.recno)"
                          style="background-color: #e612e6 !important; border-color: #e612e6 !important; color: #fff !important;"
                          >Reprint
                        </b-button>                 
                        <b-button variant="success" size="sm" @click="Viewdetails(data.item.transaction, data.item.Category)">Details</b-button>
                      </b-button-group>
                    </template>
                 </b-table>
                 <div class="row">
                  <div class="col-md-4">
                    <h5>Total Debit: <span class="text-danger">{{thousandSeperator(totals.totalout)}}</span></h5>
                  </div>
                  <div class="col-md-4">
                    <h5>Total Credit: <span class="text-danger">{{thousandSeperator(totals.totalin)}}</span></h5>
                  </div>
                  <div class="col-md-4">
                    <h5>Total Balance: <span class="text-danger">{{thousandSeperator(totals.totalout - totals.totalin)}}</span></h5>
                  </div>
                </div>
                  <div style="text-align: center">
                    <h3 v-if="!SuppliersBalanceDetails" class="text-primary">
                      <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                      Please wait...
                    </h3>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-end">
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                   </div>
                </div>
            </div>
          </div>
      </Layout>
    </template>
    